import "./Toast.scss";
import { Alert  } from "react-bootstrap";

export default function Toast({ variant, headingText, descriptionText,onClose  }) {
    return <Alert variant={variant} onClose={onClose} dismissible>
        <Alert.Heading>{headingText}</Alert.Heading>
        <p>{descriptionText}</p>
    </Alert>;
}